import { privacyPath, termsPath } from "~/common/paths"
import { Logo } from "../logo"
import { FooterLink, Copyright, AppDownload, Stars } from "./shared-footer-components"
import { getMetaContent } from "~/common/get-meta-content"

export function DesktopBottomFooter() {
  return (
    <div className="hidden h-80 w-full self-center pt-24 md:flex">
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-1 flex-row justify-between">
          <div className="flex flex-col self-end">
            <div className="flex flex-row">
              <div className="flex flex-col">
                <Logo />
              </div>

              <div className="ml-4 flex flex-row self-center">
                <FooterLink
                  href={`mailto:${getMetaContent<string>("SUPPORT_EMAIL")}`}
                  className="mx-8"
                >
                  Contact
                </FooterLink>
                <FooterLink to={termsPath({})} className="mr-8">
                  Terms of use
                </FooterLink>
                <FooterLink to={privacyPath({})}>Privacy policy</FooterLink>
              </div>
            </div>
            <Copyright />
          </div>

          <div className="flex flex-col pb-8">
            <Stars className="mb-4" />
            <AppDownload />
          </div>
        </div>
      </div>
    </div>
  )
}
